import { PlusIcon } from '@heroicons/react/24/solid';
import { useField, FieldHookConfig } from 'formik';
import tw from 'tailwind-styled-components';

interface BaseInputProps {
  hasError: boolean;
  dataType: 'text' | 'number';
}

const BaseInput = tw.input<BaseInputProps>`
block w-full shadow-sm bg-white lg:text-sm md:text-xs text-xs
${(props) =>
  !props.hasError &&
  !props.value &&
  'border-primary-300 focus:border-primary-500 focus:ring-primary-500'} 
${(props) =>
  !props.hasError &&
  !!props.value &&
  'border-primary-300 focus:border-primary-500 focus:ring-primary-500 bg-green-50'} 
${(props) =>
  props.hasError &&
  !props.value &&
  'border-primary-300 focus:border-primary-500 focus:ring-primary-500'} 
${(props) =>
  props.hasError &&
  !!props.value &&
  'border-red-300 focus:border-red-500 focus:ring-red-500 bg-red-100 '} 
${(props) => props.dataType == 'number' && 'text-right'}
${(props) => props.readOnly && 'bg-gray-50 cursor-not-allowed'}
`;

type Props = {
  label?: string;
  dataType?: 'text' | 'number';
  readonly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEditAction?: () => void;
} & FieldHookConfig<string>;

export const ActionableFormikInput: React.FC<Props> = ({
  label,
  dataType = 'text',
  readonly,
  onEditAction,
  onChange,
  ...props
}) => {
  const [field, meta] = useField(props);

  return (
    <div className="w-full">
      <label className="block lg:text-sm md:text-sm text-xs font-medium text-primary-700">
        {label}
      </label>
      <div className="mt-1 flex">
        <BaseInput
          {...field}
          dataType={dataType}
          readOnly={readonly}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            field.onChange(e);
            onChange && onChange(e);
          }}
          hasError={!!meta.error}
        />
        {meta.error ? (
          <div className="text-red-500 lg:text-sm md:text-sm text-xs">
            {meta.error}
          </div>
        ) : null}
        <button
          type="button"
          className="relative -ml-px inline-flex items-center gap-x-1.5 px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-primary-300 hover:bg-gray-50 hover:ring-primary-500"
          onClick={onEditAction}
        >
          <PlusIcon className="sm:h-5 sm:w-5 h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
